/* ============================================================
   CUSTOM ADDITION — added 14. August 2026 by OH
   Purpose: When both the sold-out badge and the Stoq preorder
   badge are present on the same product card (edge case), shift
   the preorder badge 12px to the right of the sold-out badge
   instead of letting them overlap. Both badges already share
   the same bottom offset (--sold-out-badge-overlay-bottom-offset),
   so only the horizontal position needs adjusting here.
   ============================================================ */
function positionPreorderBadgesNextToSoldOut() {
  document.querySelectorAll('.product-card').forEach((card) => {
    const preorderBadge = card.querySelector('.preorder-badge-collection');
    if (!preorderBadge) return;

    const overlay = card.querySelector('.product-card__badges-overlay');
    const soldOutBadge = overlay ? overlay.querySelector('.badge--sold-out') : null;

    if (!overlay || !soldOutBadge || overlay.offsetParent === null) {
      preorderBadge.style.left = '';
      preorderBadge.style.right = '';
      preorderBadge.style.transform = '';
      return;
    }

    const cardRect = card.getBoundingClientRect();
    const soldOutRect = soldOutBadge.getBoundingClientRect();
    const gap = 12;

    preorderBadge.style.left = `${soldOutRect.right - cardRect.left + gap}px`;
    preorderBadge.style.right = 'auto';
    preorderBadge.style.transform = 'none';
  });
}

document.addEventListener('DOMContentLoaded', positionPreorderBadgesNextToSoldOut);
window.addEventListener('resize', positionPreorderBadgesNextToSoldOut);
new MutationObserver(positionPreorderBadgesNextToSoldOut).observe(document.body, {
  childList: true,
  subtree: true
});